/*
 * Calendar Options panel component- lets users change and persist certain options for
 * viewing the tracking calendar.
 *
 * Angular module: trackerbase-app.views.tracking-calendar-view.calendar-options-panel
 * Component name: tb-calendar-options-panel (tbCalendarOptionsPanel)
 *
 */
import angular from "angular";

import uiRouter from "@uirouter/angularjs";

import DependencyListBuilder from "../../utility/DependencyListBuilder";

import CalendarOptionsPanelController from "./CalendarOptionsPanelController";

const CalendarOptionsPanelComponent = {
    name: "tbCalendarOptionsPanel",
    config: {
        template: CalendarOptionsPanelController.template,
        bindings: {
            additionalPanelClasses: "@tbAdditionalPanelClasses",
            panelIsOpen: "=tbPanelIsOpen",
            panelInitialized: "=tbPanelIsInitialized",
            applyCalendarOptions: "&tbApplyCalendarOptions"
        },
        controller: CalendarOptionsPanelController,
        controllerAs: CalendarOptionsPanelController.controllerAs
    }
};

const calendarOptionsPanelComponentDependencies = DependencyListBuilder([
    CalendarOptionsPanelController.dependencies,
    [
        uiRouter
    ]
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-calendar-view.calendar-options-panel",
        calendarOptionsPanelComponentDependencies
    )
    .component(CalendarOptionsPanelComponent.name, CalendarOptionsPanelComponent.config)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/CalendarOptionsPanel.js
// module id = YrLc
// module chunks = 1